import React from "react";
import { useLoaderData } from "react-router";

import Filters from "./components/Filters";
import FiltersSubRow from "./components/FiltersSubRow";
import RatingsTable from "./components/RatingsTable";
import { FiltersProvider } from "./contexts/Filters";
import { RatingsProvider, useRatingsContext } from "./contexts/Ratings";

import Pagination from "../../../../../components/Pagination";
import { PaginationProvider } from "../../../../../contexts/Pagination";
import { getUmpireRatingAverages } from "../../../../../lib/api";
import { IUmpireRatingAverage } from "../../../../../types/api";

export const loader = async () => {
    const [{ ratings }] = await Promise.all([
        getUmpireRatingAverages(undefined, true),
    ]);

    return {
        ratings,
    };
};

const Ratings = (): React.JSX.Element => {
    const { ratings } = useLoaderData() as { ratings: IUmpireRatingAverage[] };
    ratings.sort((a, b) =>
        a.umpire.name.toLowerCase() > b.umpire.name.toLowerCase() ? 1 : -1,
    );

    return (
        <FiltersProvider>
            <Filters />

            <PaginationProvider>
                <RatingsProvider initialRatings={ratings}>
                    <FiltersSubRow />
                    <RatingsTable />
                    <Pagination useContext={useRatingsContext} />
                </RatingsProvider>
            </PaginationProvider>
        </FiltersProvider>
    );
};

export default Ratings;
